import { fromJS } from 'immutable'
import {
  DEPARTMENT_LIST_REQUEST,
  DEPARTMENT_LIST_SUCCESS,
  DEPARTMENT_LIST_FAILURE,
  DEPARTMENT_LIST_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case DEPARTMENT_LIST_REQUEST:
      return state
        .set('isFetching', false)
    case DEPARTMENT_LIST_SUCCESS:
      return state
        .set('department', fromJS(action.payload.departments))
    case DEPARTMENT_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('department', [])
        .set('isFetching', false)
    case DEPARTMENT_LIST_RESET:
      return state
        .set('redirect', false)
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/department/department-list-reducer.js